import React from 'react';
import styles from './index.module.less';
import classes from 'classnames';

const CourseCatalog = ({ className, catalogs = [] }) => {
  return (
    <div className={classes(styles['course-catalog'], className)}>
      <div className={styles.title}>课程内容</div>
      {catalogs.map((catalog, index) => {
        return (
          <div className={styles['catalog-item']} key={index}>
            <div className={styles['chapter-header']}>{catalog.chapter}</div>
            <div className={styles['chapter-body']}>
              <div className={styles['name']}>{catalog.name}</div>
              <div className={styles.desc}>{catalog.desc}</div>
              <div className={styles.lesson}>{catalog.lessons}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CourseCatalog;
